export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '5718e187-8f16-457d-9c22-e1412c49fc0c';
export const MODAL_CLOSE_SEC = 2.5;
